module.exports = __webpack_public_path__ + "static/media/close.127cbb2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 23
// module chunks = 0